import { createSelector } from 'reselect'
import selectTrelloLabelsById from './selectTrelloLabelsById'

export default createSelector(selectTrelloLabelsById, labels => {
  if (!labels) return labels
  return Object.values(labels)
})
